import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueries";

export const userAPI = createApi({
    reducerPath: "userAPI",
    baseQuery: baseQueryWithReauth,
    tagTypes: ["Profile", "NodeUser"],
    endpoints: (builder) => ({
        profile: builder.query({
            query: () => ({
                url: "/api/auth/me/",
                method: "GET",
            }),
            providesTags: ["Profile"],
        }),
        inviteUser: builder.mutation({
            query: ({ invitee_email, role, nodes_allocated }) => ({
                url: "/api/tenants/invite/",
                method: "POST",
                body: {
                    invitee_email,
                    role,
                    nodes_allocated,
                },
            }),
        }),
        updateUser: builder.mutation({
            query: ({ first_name, last_name }) => ({
                url: "/api/tenants/users/",
                method: "PUT",
                body: {
                    first_name,
                    last_name,
                },
            }),
        }),
        resendInviteUser: builder.mutation({
            query: ({ id }) => ({
                url: "/api/tenants/invite/",
                method: "PUT",
                body: {
                    id,
                },
            }),
        }),
        deleteUser: builder.mutation({
            query: ({ id }) => ({
                url: "/api/tenants/invite/",
                method: "DELETE",
                body: {
                    id,
                },
            }),
        }),

        // SCT user Management
        inviteSCTUser: builder.mutation({
            query: ({
                invitee_email,
                first_name,
                last_name,
                role,
                nodes_allocated,
                resend_email,
                is_active,
            }) => ({
                url: "/api/sct-user-management/",
                method: "POST",
                body: {
                    invitee_email,
                    first_name,
                    last_name,
                    role,
                    nodes_allocated,
                    resend_email,
                    is_active,
                },
            }),
            invalidatesTags: (result, error, arg) => ["NodeUser"],
        }),
        getAllSCTUsers: builder.query({
            query: () => ({
                url: "/api/sct-user-management/",
                method: "GET",
            }),
            invalidatesTags: ["NodeUser"],
        }),
        getNodeUserDetails: builder.query({
            query: (id) => ({
                url: `/api/sct-user-management/${id}/`,
                method: "GET",
            }),
            providesTags: (result, error, id) => [{ type: "NodeUser", id }],
        }),
    }),
});

export const {
    useLazyProfileQuery,
    useProfileQuery,
    useInviteUserMutation,
    useUpdateUserMutation,
    useResendInviteUserMutation,
    useDeleteUserMutation,
    useInviteSCTUserMutation,
    useGetAllSCTUsersQuery,
    useGetNodeUserDetailsQuery,
} = userAPI;
